import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "chart.js/auto";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { queryClient } from "./services/queryClient";
import { DashboardLoginProvider } from "./services/DashboardLoginContext";
import { registerServiceWorker } from "./pwa/registerServiceWorker";
import { initInspectionGuard } from "./utilities/inspectionGuard";

registerServiceWorker();
initInspectionGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <DashboardLoginProvider>
          <App />
        </DashboardLoginProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals(() => {});
